import * as React from 'react';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from '@mui/material/Alert';
import { Link, useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import './Header.css'

function Header(props) {

    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [usernameLogin, setUsernameLogin] = useState('');

    const navigate = useNavigate();

    const logOut = () => {
        localStorage.removeItem('token');
        props.setLogged(false);
        navigate('/', {replace: true});

    }

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.target);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        // Get the modal
        var modal = document.getElementById("myModal");

        // Get the <span> element that closes the modal
        var span = document.getElementById("close");

        // When the user clicks on <span> (x), close the modal
        span.onclick = function() {
            modal.style.display = "none";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = "none";
            }
        }
    })

    const logIn = async (event) => {
        event.preventDefault();
        setLoading(true);
        await fetch(`${props.url}/procesos-api/token-auth`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: usernameLogin,
                password: password
            }),
        })
        .then(res => res.json())
        .then(json => {
            // If token is returned
            if (json.token) {
                // Hide the modal
                var modal = document.getElementById("myModal");
                modal.style.display = "none";
                // Save token
                localStorage.setItem('token', json.token);
                // Hide alert
                setAlert(false);
                props.setLogged(true)
                navigate('/', {replace: true});
                props.setUsername(usernameLogin);
            } else {
                // Display alert
                setAlert(true);
            }
        })
        setLoading(false);
        setUsernameLogin('');
        setPassword('');
    }

    return(
        <Container className="header">
            <div className='inner-container'>
                <Row>
                    <Col className="d-flex justify-content-start">
                        <div className="logo">
                            <Link to='/' id="logo">
                                <img id="logo" src={require('../Media/rollin_red_logo_and_name.png')} alt="rollin logo and name" />
                            </Link>
                        </div>
                    </Col>
                    
                    <Col id='rollin-logo-title' className="d-flex justify-content-end">
                        {
                            props.logged ? 
                                            <React.Fragment>
                                                <div className='menu-big'>
                                                    <Link className='menu-text' to='/mis-procesos'>MisProcesos</Link>
                                                    <Link className='menu-text' to='/importantes'>Importantes</Link>
                                                    <Link className='menu-text' to='/archivados'>Archivados</Link>
                                                </div>
                                                    <div id='avatar'><Tooltip  title={props.username}>
                                                        <IconButton
                                                            onClick={handleClick}
                                                            size="small"
                                                            sx={{ ml: 2 }}
                                                            aria-controls={open ? 'account-menu' : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={open ? 'true' : undefined}
                                                        >
                                                            <Avatar sx={{ width: 32, height: 32 }}>{props.username.slice(0,1).toUpperCase()}</Avatar>
                                                        </IconButton>
                                                    </Tooltip>
                                                    </div>
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        id="account-menu"
                                                        open={open}
                                                        onClose={handleClose}
                                                        onClick={handleClose}
                                                        PaperProps={{
                                                        elevation: 0,
                                                        sx: {
                                                            overflow: 'visible',
                                                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                            mt: 1.5,
                                                            '& .MuiAvatar-root': {
                                                            width: 32,
                                                            height: 32,
                                                            ml: -0.5,
                                                            mr: 1,
                                                            },
                                                            '&:before': {
                                                            content: '""',
                                                            display: 'block',
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 14,
                                                            width: 10,
                                                            height: 10,
                                                            bgcolor: 'background.paper',
                                                            transform: 'translateY(-50%) rotate(45deg)',
                                                            zIndex: 0,
                                                            },
                                                        },
                                                        }}
                                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                    >
                                                        <MenuItem onClick={() => navigate('/', {replace: true})}>
                                                            <div className='menu-icon'><span className="material-icons-round">home</span></div>
                                                            <div className='menu-text'>&nbsp;&nbsp;&nbsp;&nbsp;Inicio</div>
                                                        </MenuItem>
                                                        <MenuItem onClick={() => navigate('/mis-procesos', {replace: true})}>
                                                            <div className='menu-icon'><span className="material-icons-round">gavel</span></div>
                                                            <div className='menu-text'>&nbsp;&nbsp;&nbsp;&nbsp;Mis Procesos</div>
                                                        </MenuItem>
                                                        <MenuItem onClick={() => navigate('/importantes', {replace: true})}>
                                                            <div className='menu-icon'><span className="material-icons-round">star</span></div>
                                                            <div className='menu-text'>Importantes</div>
                                                        </MenuItem>
                                                        <MenuItem onClick={() => navigate('/archivados', {replace: true})}>
                                                            <div className='menu-icon'><span className="material-icons-round">folder_off</span></div>
                                                            <div className='menu-text'>Archivados</div>
                                                        </MenuItem>
                                                        <MenuItem onClick={logOut}>
                                                            <div className='menu-icon'><span className="material-icons-round">logout</span></div>
                                                            <div className='menu-text'>Salir</div>
                                                        </MenuItem>
                                                        
                                                    </Menu>
                                            </React.Fragment>
                                         : <div id="logIn" className="log-in" onClick={() => {document.getElementById("myModal").style.display = "block"}}>
                                                Ingresa<span className="material-icons-round log">gavel</span>
                                            </div>
                                         
                                         
                        }
                    </Col>
                </Row>
            </div>

            <div id="myModal" className="modal">
                <div className="modal-content">
                    <div id="close">&times;</div>
                    {alert ? <Alert onClose={() => setAlert(false)} severity={"error"} sx={{ width: '100%' }}>
                        Usaurio o contraseña incorrectos
                    </Alert> : null}
                    <Form onSubmit={(event) => logIn(event)}>
                        <div className="logInTitle">Ingresa</div>
                        { loading ? <div id='login-circle'><CircularProgress /></div> :
                        <Form.Group>
                            <div id='text-field'>
                                <TextField className="filled-basic" placeholder="Usuario" type="text" variant="filled"
                                           onChange={(e) => setUsernameLogin(e.target.value)}/>
                            </div>
                            <div id='text-field'>
                                <TextField className="filled-basic" placeholder="Contraseña"type="password" variant="filled"
                                           onChange={(e) => setPassword(e.target.value)}/>
                            </div>
                        </Form.Group>
                        }
                        <div className="buttonWrapper"><Button type='submit'>Log In</Button>
                        </div>
                    </Form>
                </div>
            </div> 
        </Container>
    )
}

export { Header }